import type { CarriedItemLoss } from '@sorrem/shared';

/** Opens every party-wipe message: what a wipe always costs, and that in-run gear changes are undone. */
export const PARTY_WIPE_SUMMARY = 'Collected essence was forfeited, and you return with only what you carried in.';

/**
 * What a party wipe did to the local player's carried items, and why;
 * `loss` is their entry in `GameEndedPayload.carriedItemLosses`, if any,
 * and `waived` whether the run waived defeat penalties (no item at stake).
 */
export function describeDefeatItemLoss(loss: CarriedItemLoss | undefined, waived = false): string {
    if (waived) {
        return 'This Crucible spares the fallen: the Veil took nothing from you.';
    }
    if (loss === undefined) {
        return 'The balance held, and the Veil took nothing from you.';
    }
    if (loss.reason === 'above-band') {
        return loss.item === null
            ? 'You were stronger than this Crucible calls for, but you carried nothing for the Veil to take.'
            : `You were stronger than this Crucible calls for. To restore the balance, the Veil took your ${loss.item.name}.`;
    }
    return loss.item === null
        ? 'Resonance runs too deep here for anyone to fall untouched, but you carried nothing for the Veil to take.'
        : `Resonance runs too deep here for anyone to fall untouched. The Veil took your ${loss.item.name}.`;
}
